<template>
    <v-container
        fluid
        class="pa-0"
    >
        <div class="home-content">
            <v-row class="mt-6">
                <v-col
                    v-for="(partnerInfo, index) in this.partnersInfo"
                    :key="index"
                    class="px-2"
                    cols="12"
                    sm="6"
                    md="4"
                    lg="3"
                >
                    <partners-card
                        :imgUrl="partnerInfo.image"
                        :linkUrl="partnerInfo.link"
                    />
                </v-col>
            </v-row>
        </div>
    </v-container>
</template>
<script>
import PartnersCard from '@/components/partners/PartnersCard.vue'
import { usePartnersStore } from '@/store/partners'
export default {
    name: 'PartnersCards',
    components: {
        PartnersCard
    },
    data() {
        let partnersInfo = []

        return {
            partnersInfo
        }
    },
    async mounted() {
        const partnersStore = usePartnersStore()

        await partnersStore.getPartners(0, 8)
        this.partnersInfo = partnersStore.allPartners
    }
}
</script>
